
// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://hvwftdcqgaqurygqnfyv.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imh2d2Z0ZGNxZ2FxdXJ5Z3FuZnl2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDI1NzM2MjksImV4cCI6MjA1ODE0OTYyOX0.vBqNFFpuGxe6OKzsB6X8VT42VXEbTSOt9F2tl75w1wM";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(
  SUPABASE_URL, 
  SUPABASE_PUBLISHABLE_KEY,
  {
    auth: {
      storage: localStorage,
      autoRefreshToken: true,
      persistSession: true,
      detectSessionInUrl: true
    }
  }
);
